"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.editorZIndex = void 0;
var theme_1 = require("../../../../theme");
exports.editorZIndex = (_b = (_a = theme_1.theme.tokens) === null || _a === void 0 ? void 0 : _a.zIndex) !== null && _b !== void 0 ? _b : '9999999';
